import { api } from "@/lib/api";

export async function downloadStaffXlsx(params) {
  const res = await api.get("/staff/reports/export.xlsx", { params, responseType: "blob" });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(res.data);
  a.download = `billone-staff-${params.kind}-${params.month || params.date_from || ""}.xlsx`;
  a.click();
  URL.revokeObjectURL(a.href);
}

export function printTable(title, subtitle, headers, rows) {
  const w = window.open("", "_blank");
  if (!w) return;
  const th = headers.map((h) => `<th>${h}</th>`).join("");
  const tr = rows.map((r) => `<tr>${r.map((c) => `<td>${c ?? ""}</td>`).join("")}</tr>`).join("");
  w.document.write(`<html><head><title>${title}</title><style>body{font-family:Arial;padding:16px;font-size:11px}h2{margin:0}table{width:100%;border-collapse:collapse;margin-top:10px}th,td{border:1px solid #cbd5e1;padding:4px 6px;text-align:left}th{background:#eef2ff}</style></head><body><h2>${title}</h2><div>${subtitle}</div><table><thead><tr>${th}</tr></thead><tbody>${tr}</tbody></table><script>window.onload=function(){window.print();}</script></body></html>`);
  w.document.close();
}
